import React from 'react';
import propTypes from 'prop-types';
import { useSitemap, useLabels } from 'wsm-common-data';

const DialogLink = ({
	pageAlias = '',
	dataTitle = '',
	dataContent = '',
	linkLabel = ''
}) => {
	const sitemap = useSitemap();
	const labels = useLabels();
	return (
		<a
			className="btn btn-link dialog my-sm-4"
			href={sitemap.get(pageAlias)}
			data-title={labels.get(dataTitle)}
			data-content={labels.get(dataContent)}
			data-width="800"
		>
			{labels.get(linkLabel)}
		</a>
	);
};

DialogLink.propTypes = {
	pageAlias: propTypes.string.isRequired,
	dataTitle: propTypes.string.isRequired,
	dataContent: propTypes.string.isRequired,
	linkLabel: propTypes.string.isRequired
};

export default DialogLink;
